firebird.directive('starRating', [
    function () {
        return {
            restrict: 'AE',
            scope: {
                handler: '&starRatingHandler'
            },
            link: function (scope, element, attrs) {
                element.rating();
                element.on('change', function () {
                    var value = $(this).val();
                    $(this).val(0);
                    scope.handler()(value);
                });
            }
        };
    }
]);
